module.exports = __webpack_public_path__ + "assets/img/workLogo.57c4b154.png";